<template>
    <modal width="920" height="auto" name="pc-basket-continue-checkout-modal" data-html2canvas-ignore="true"
        :adaptive="true" class="pc-basket-continue-checkout-modal" :scrollable="false">
        <div class="pc-basket-continue-checkout-modal-container">
            <button class="continue-checkout-modal-button-close btn button-full" type="button" @click="closeModal">
                <span class="png-icon png-icon-icons-symbols--k-txtclose" aria-label="Close modal"></span>
            </button>
            <div class="pc-basket-continue-checkout-modal-wrapper">
                <div class="pc-basket-continue-checkout-modal-header">
                    <div class="continue-checkout-modal-header">
                        <h3>{{ $resourceString['myBasket.ContinueShipping.Modal.Title'] }}</h3>
                        <p>{{ $resourceString['myBasket.ContinueShipping.Modal.Description'] }}</p>
                    </div>
                </div>
                <div class="pc-basket-continue-checkout-modal-body">
                    <!-- Individual Samples -->
                    <div class="pc-basket-continue-checkout-modal-list" v-if="(basketItems && basketItems.SiteItems && basketItems.SiteItems.length > 0)">
                        <div class="pc-basket-continue-checkout-modal-list-label">
                            <input class="continue-checkout-form-check-input" type="radio" name="continueCheckout"
                                id="individual-samples" :value="site" v-model="checkoutTypeOption"/>
                            <label for="individual-samples" class="continue-checkout-form-check-label">
                                {{ $resourceString['myBasket.Label.IndividualSamples'] }}: {{ (basketItems.SiteItems.length) || 0 }}
                            </label>
                        </div>
                    </div>
                    <!-- Project Samples -->
                    <div class="pc-basket-continue-checkout-modal-list" v-if="(basketItems && basketItems.ProjectItems && basketItems.ProjectItems.length > 0)">
                        <div class="pc-basket-continue-checkout-modal-list-label">
                            <input class="continue-checkout-form-check-input" type="radio" name="continueCheckout"
                                id="project-samples" :value="project" v-model="checkoutTypeOption" />
                            <label for="project-samples" class="continue-checkout-form-check-label">
                                {{ $resourceString['myBasket.Label.ProjectSamples'] }}: {{ (basketItems.ProjectItems.length) || 0 }}
                            </label>
                        </div>
                    </div>
                    <!-- Design Tray Samples -->
                    <div class="pc-basket-continue-checkout-modal-list" v-if="(basketItems && basketItems.TrayItems && basketItems.TrayItems.length > 0)">
                        <div class="pc-basket-continue-checkout-modal-list-label">
                            <input class="continue-checkout-form-check-input" type="radio" name="continueCheckout"
                                id="design-tray-samples" :value="tray" v-model="checkoutTypeOption" />
                            <label for="design-tray-samples" class="continue-checkout-form-check-label">
                                {{ $resourceString['myBasket.Label.DesignTraySample'] }}: {{ (basketItems.TrayItems.length) || 0 }}
                            </label>
                        </div>
                    </div>
                </div>
                <div class="pc-basket-continue-checkout-modal-footer">
                    <button type="button" :disabled="!checkoutTypeOption" class="btn btn-primary next-btn" @click="continueToCheckOut">
                        <span class="btn-label">{{ $resourceString['myBasket.Button.ContinueToShipping'] }}</span>
                        <span class="png-icon png-icon-icons-glyph--ko-arrow-next"></span>
                    </button>
                </div>
            </div>
        </div>
    </modal>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import BasketItem from "./pc-basket-list.vue";
import { CHECKOUT_TYPE_SITE, CHECKOUT_TYPE_PROJECT, CHECKOUT_TYPE_TRAY } from "../../../constants/checkout-constant";
import { BEGIN_CHECKOUT_EVENT_NAME } from "../../../constants/gtm-constants";

export default {
    props: {
        defaultSelected: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            site: CHECKOUT_TYPE_SITE,
            project: CHECKOUT_TYPE_PROJECT,
            tray: CHECKOUT_TYPE_TRAY,
            checkoutTypeOption: "",
            GTMEventName: BEGIN_CHECKOUT_EVENT_NAME,
        }
    },
    components: {
        BasketItem
    },
    watch: {
        defaultSelected: function() {
            this.checkoutTypeOption = this.defaultSelected;
        },
        checkoutTypeOption: function(newValue, oldValue) {
            if(newValue !== oldValue) {
                this.updateCheckoutTypeProceed(this.checkoutTypeOption)
            }
        },
    },
    computed: {
        ...mapGetters({
            basketItems: "newBasketPage/getBasketItems",
            checkoutType: "newBasketPage/getCheckoutTypeProceed",
        })
    },
    methods: {
        ...mapActions({
            updateCheckoutTypeProceed: "newBasketPage/updateCheckoutTypeProceed",
            checkOutPost: "newBasketPage/checkOutPost",
        }),
        closeModal() {
            this.$modal.hide("pc-basket-continue-checkout-modal");
        },
        async continueToCheckOut() {
            let selectedBasketItems = [];
            const self = this;
            const payload = {
                checkoutType: this.checkoutType
            }

            if(this.checkoutType === CHECKOUT_TYPE_SITE) {
                selectedBasketItems = this.basketItems?.SiteItems
            } else if(this.checkoutType === CHECKOUT_TYPE_PROJECT) {
                selectedBasketItems = this.basketItems?.ProjectItems
            } else if(this.checkoutType === CHECKOUT_TYPE_TRAY) {
                selectedBasketItems = this.basketItems?.TrayItems
            }            
            this.$gtm.viewCartEvent(selectedBasketItems, this.GTMEventName);
            const status = await self.checkOutPost(payload);
            if(status) {
                self.closeModal()
            }
        },
    },
}
</script>